import { render, staticRenderFns } from "./UnableToOffer.vue?vue&type=template&id=7153bb7f"
import script from "./UnableToOffer.vue?vue&type=script&lang=js"
export * from "./UnableToOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports